module.exports = __webpack_public_path__ + "static/media/ionic.779f6137.jpg";